import * as storeTypes from './category.store-types';
import axios from 'axios';
import {Category} from './models/category.models';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isActiveRequest: false,
        isTemplate: false,
        categories: [],
        templateCategories: [],
        currentCategory: new Category()
    },
    mutations: {
        [storeTypes.SET_CATEGORIES]: (state, categories) =>
            (state.categories = categories),
        [storeTypes.SET_CURRENT_CATEGORY]: (state, currentCategory) =>
            (state.currentCategory = currentCategory),
        [storeTypes.SET_IS_LOADING]: (state, isLoading) =>
            (state.isLoading = isLoading),
        [storeTypes.SET_IS_ACTIVE_REQUEST]: (state, isActiveRequest) =>
            (state.isActiveRequest = isActiveRequest),
        [storeTypes.SET_IS_TEMPLATE]: (state, isTemplate) =>
            (state.isTemplate = isTemplate),
    },
    actions: {
        async [storeTypes.ACTION_GET_CATEGORIES](store, {name = '', companyId = ''}) {
            store.commit(storeTypes.SET_IS_LOADING, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {

                        let url = `/api/categories?name=${name}&isTemplate=${store.state.isTemplate}`;

                        if (companyId.length) {
                            url = `/api/companies/${companyId}/categories`;
                        }

                        const {
                            data: {success, error, categories}
                        } = await axios.get(url);

                        if (!success) {
                            return reject(error);
                        }

                        store.commit(
                            storeTypes.SET_CATEGORIES,
                            categories.map(category => Category.fromArray(category.category || category))
                        );
                        resolve();
                    } catch ({
                        response: {
                            data: {error}
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_LOADING, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_CREATE_CATEGORY](store, {category, selectedCompanies = [], selectedUsersGroups = []}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {
                            data: {success}
                        } = await axios.post("/api/categories", {category, selectedCompanies, selectedUsersGroups});

                        if (success) {
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: {error}
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_UPDATE_CATEGORY](store, {category, selectedCompanies = null, selectedUsersGroups = [], isTemplateFlow = false}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {
                            data: {success}
                        } = await axios.put(`/api/categories/${category._id}`, {
                            category,
                            selectedCompanies,
                            selectedUsersGroups,
                            isTemplateFlow
                        });

                        if (success) {
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: {error}
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_REMOVE_CATEGORY](store, {category}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {
                            data: {success}
                        } = await axios.put(`/api/categories/remove/${category._id}`);

                        if (success) {
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: {error}
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_UPDATE_CATEGORY_REQUIRED_TEST_RESULTS](store, {category}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {
                            data: {success}
                        } = await axios.post('/api/categories/update-tests', {categoryId: category._id});

                        if (success) {
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: {error}
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            })
        },
        async [storeTypes.ACTION_CLONE_TEMPLATE_CATEGORY](store, {category, companyId}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {
                            data: {success}
                        } = await axios.put(`/api/categories/${companyId}/clone-template-category`, {
                            category,
                        })

                        if (success) {
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: {error}
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            })
        }
    },
    getters: {
        [storeTypes.GET_CATEGORIES]:
            state => state.categories,
        [storeTypes.GET_CURRENT_CATEGORY]:
            state => state.currentCategory,
        [storeTypes.GET_IS_LOADING]:
            state => state.isLoading,
        [storeTypes.GET_IS_ACTIVE_REQUEST]:
            state => state.isActiveRequest,
        [storeTypes.GET_IS_TEMPLATE]:
            state => state.isTemplate
    }
};